import React from 'react';
import { PropertyAddressSearchResultDto } from 'api';
import { Table, TableBody, TableHead, TableCell, TableContainer, TableFooter, TablePagination, TableRow } from 'ui-library/table';
import styled, { createGlobalStyle, css } from 'themed-components';
import { Box, Card, Grid, Typography, withStyles } from '@material-ui/core';

import _ from 'lodash';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { Skeleton } from '@material-ui/lab';
const StyledCard = styled(Card)`
	padding: 0.5rem;
`;

export interface PropertySearchResultsProps {
	data?: PropertyAddressSearchResultDto[] | null;
	loading: boolean;
	onChange: (entity?: PropertyAddressSearchResultDto) => void;
	selectedValue?: PropertyAddressSearchResultDto;
}

const BoxWrapper = styled.div`
	padding: 0.25rem;
`;

const StyledToggleButtonGroup = withStyles((theme) => ({
	grouped: {
		style: {
			display: 'flex',
			flex: 1
		},
		'&': {
			flexDirection: 'column',
			flex: 2
		},

		'&.Mui-selected': {
			backgroundColor: theme.palette.primary.dark,
			color: theme.palette.primary.contrastText
		},
		'&:hover:not(.Mui-selected)': {
			backgroundColor: theme.palette.primary.light,
			color: theme.palette.primary.contrastText
		},
		'&:hover.Mui-selected': {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText
		}
	}
}))(ToggleButtonGroup);

const StyledSkeleton = styled(Skeleton)`
	padding-bottom: 0.1rem;
`;

const LoadingSkeleton = () => (
	<>
		<StyledSkeleton variant="rect" height={50} width="100%" />
		<StyledSkeleton variant="circle" width={80} height={80} />
		<StyledSkeleton variant="rect" height={218} width="100%" />
	</>
);

export const PropertySearchResults = ({ data, loading, onChange, selectedValue }: PropertySearchResultsProps) => {
	if (_.size(data) == 0 && !loading) return null;

	return (
		<Table>
			<TableBody>
				<TableRow>
					{loading && (
						<TableCell colSpan={2}>
							<LoadingSkeleton />
						</TableCell>
					)}
					{!loading && (
						<TableCell colSpan={2}>
							<StyledToggleButtonGroup
								orientation="vertical"
								value={selectedValue?.entityId}
								exclusive
								color="primary"
								aria-label="mail type"
							>
								{_.map(_.take(data, 10), (d, i) => {
									const onToggleChange = () => onChange(d);
									return (
										<ToggleButton
											onClick={onToggleChange}
											key={`$searchResult${i}`}
											selected={selectedValue?.entityId == d.entityId}
											value={d.entityId}
											aria-label="address search results"
										>
											<Grid container direction="column" alignItems="flex-start">
												<Grid item>
													<Box component={BoxWrapper}>{d.companyName}</Box>
												</Grid>
												<Grid item>
													<Box component={BoxWrapper}>{d.propertyName}</Box>
												</Grid>
												<Grid item>
													{_.map(d.propertyOwners, (x) => {
														return (
															<Box component={BoxWrapper}>
																{x.firstName} {x.lastName}
															</Box>
														);
													})}
												</Grid>
											</Grid>
										</ToggleButton>
									);
								})}
							</StyledToggleButtonGroup>
						</TableCell>
					)}
				</TableRow>
			</TableBody>
		</Table>
	);
};
